import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import GrantFinder from "@/pages/GrantFinder";

export const Route = createFileRoute("/grant-finder")({
  head: () => seoHead("/grant-finder"),
  component: GrantFinder,
});
